import {reloadGridDetailContent} from "../../grid/detail";

export function initK1Confirms() {
	$('body').on('click', 'a[data-confirm]', function (event) {
		let $a = $(this)
		event.preventDefault()

		k1Confirm($a.data('confirm'), $a.data('title'))
			.then(function () {
				if ($a.attr('data-confirm-click')) {
					$($a.attr('data-confirm-click')).click();
					return ;
				}

				najaGlobal.makeRequest('GET', $a.attr('href')).then((payload) => {
					if (! payload.result) {
						staticNotification.error(payload.errorMessage);
					}

					if (payload.result) {
						staticNotification.success('Požadavek úspěšně proveden.');
					}

					if (payload.errorMessage) {
						staticNotification.error(payload.errorMessage);
					}

					if ($a.data('after') === 'reload-detail') {
						reloadGridDetailContent();
					}

					if ($a.data('after') === 'close-modal') {
						$("[data-role=window]").data("kendoWindow").close();
					}

					if ($a.data('after') == 'reload') {
						window.location.reload();
					}

					if (typeof $a.data('detach') !== 'undefined') {
						$a.closest('tr').detach()
						$a.closest('li').detach()
						$a.closest('[detach-container]').detach()
					}
				}).catch((error) => {
					if ('name' in error && error.name === 'HttpError') {
						console.log(error.response);
					}
				});
			}, function () {
				console.log("Cancel")
			});
	})
}

export function k1Confirm(content, title) {
	if (typeof title === 'undefined' || title === null) {
		title = 'K1';
	}

	return $("<div></div>").kendoConfirm({
		title: title,
		content: content,
		show: function () {
			$('.k-dialog-buttongroup .k-button-solid-primary').focus();
		}
	}).data("kendoConfirm").open().result;
}

window.k1Confirm = k1Confirm